<template>
  <v-container fluid>
    <v-toolbar>
      <v-toolbar-title>{{ $t('WAREHOUSE.ITEM') }} </v-toolbar-title>

      <v-spacer />

      <v-btn
        v-if="$can('sensitive-data')"
        dark
        color="indigo"
        @click="create()"
      >
        <v-icon left>mdi-plus</v-icon>
        {{ $t('ITEM.NEW') }} {{ $t('DEVICES.ITEM') }}
      </v-btn>
    </v-toolbar>

    <v-sheet class="mt-5 pa-5" tile>
      <devices-list-filter @setRequest="setFilters" />

      <devices-list
        :meta="meta"
        :devices="devices"
        :options.sync="options"
        :type="$options.WAREHOUSE"
        @show="show"
      />
    </v-sheet>

    <v-dialog
      v-if="dialog"
      v-model="dialog"
      persistent
      width="unset"
      max-width="600"
    >
      <component
        :is="component.name"
        v-bind="component.data"
        @created="cancelDialogAndRefresh"
        @updated="cancelDialogAndRefresh"
        @cancel="cancelDialog"
      />
    </v-dialog>
  </v-container>
</template>

<script>
import DevicesList, {
  WAREHOUSE
} from '@/modules/devices/components/DeviceList.vue';
import DevicesListFilter from '../components/WarehouseDevicesListFilter.vue';
import DataOptions from '@/modules/_global/classes/DataOptions';
import { WarehouseDevicesService } from '@/services/warehouse-devices.service';

export default {
  name: 'WarehouseDevicesPage',

  WAREHOUSE,

  components: {
    DevicesList,
    DevicesListFilter,
    CreateDevice: () =>
      import('@/modules/devices/Warehouse/components/CreateDevice.vue'),
    EditDevice: () =>
      import('@/modules/devices/Warehouse/components/EditDevice.vue')
  },

  data() {
    return {
      meta: {},
      devices: [],
      filters: {
        show_all: false
      },
      options: {
        page: 1,
        itemsPerPage: 10,
        sortBy: ['id'],
        sortDesc: [true],
        groupBy: [],
        groupDesc: [],
        mustSort: false,
        multiSort: false
      },
      dialog: false,
      component: null
    };
  },

  computed: {
    preparedOptions() {
      return DataOptions.createFromObject(this.options).toBackendFormat();
    },

    params() {
      return Object.assign({}, this.filters, this.preparedOptions);
    }
  },

  watch: {
    options: {
      deep: true,
      immediate: true,
      handler() {
        this.refreshData();
      }
    },
    filters: {
      deep: true,
      handler() {
        this.options.page = 1;
        this.refreshData();
      }
    }
  },

  methods: {
    refreshData() {
      WarehouseDevicesService.getList(this.params).then(({ data }) => {
        this.devices = data.data;
        this.meta = data.meta;
      });
    },

    setFilters(filters) {
      this.filters = filters;
    },

    create() {
      this.dialog = true;
      this.component = {
        name: 'CreateDevice'
      };
    },

    show(device) {
      this.dialog = true;
      this.component = {
        name: 'EditDevice',
        data: {
          id: device.id,
          showDetails: true
        }
      };
    },

    cancelDialog() {
      this.dialog = false;
      this.component = null;
    },

    cancelDialogAndRefresh() {
      this.refreshData();
      this.cancelDialog();
    }
  }
};
</script>

<style scoped></style>
